var labels = {
  ownership_title: {
    es: 'Asignación de propietario',
    en: 'Ownership'
  },
  requests_title: {
    es: 'Solicitudes de acceso',
    en: 'Access requests'
  },
  metadata_title: {
    es: 'Solicitudes de cambio de metadatos',
    en: 'Change metadata requests'
  },
  massive_title: {
    es: 'Solicitudes masivas',
    en: 'Massive setup requests'
  },
  massive_subtitle: {
    es: 'Solicitudes generadas por un usuario que le asignó un Perfile de Usuario',
    en: 'Requests generated by a user assigned a User Profile.'
  },
  ownership: {
    nivel: 2,
    subtitle_tables: {
      es: 'Aprobaciones de operador para tablas de BigQuery',
      en: 'Data operator approvals for BigQuery tables'
    },
    subtitle_datasources: {
      es: 'Aprobaciones de operador para datasources de Tableau',
      en: 'Data operator approvals for Tableau Datasources'
    },
    subtitle_dashboards: {
      es: 'Aprobaciones de operador para dashboards de Tableau',
      en: 'Data operator approvals for Tableau Dashboards'
    },
    subtitle_datasets: {
      es: 'Aprobaciones de operador para datasets de PowerBI',
      en: 'Data operator approvals for PowerBI Datasets'
    },
    subtitle_reports: {
      es: 'Aprobaciones de operador para reportes de PowerBI',
      en: 'Data operator approvals for PowerBI Reports'
    },
    subtitle_reports_lds: {
      es: 'Aprobaciones de operador para reportes de Looker Data Studio',
      en: 'Data operator approvals for Looker Data Studio Reports'
    },
    subtitle_datasources_gds: {
      es: 'Aprobaciones de operador para datasources de Looker Data Studio',
      en: 'Data operator approvals for Looker Data Studio Datasources'
    }
  },
  requests: {
    nivel: 2,
    subtitle_tables: {
      es: 'Solicitudes de acceso para tablas de BigQuery',
      en: 'Access requests for BigQuery tables'
    },
    subtitle_datasources: {
      es: 'Solicitudes de acceso para datasources de Tableau',
      en: 'Access requests for Tableau Datasources'
    },
    subtitle_dashboards: {
      es: 'Solicitudes de acceso para dashboards de Tableau',
      en: 'Access requests for Tableau Dashboards'
    },
    subtitle_datasets: {
      es: 'Solicitudes de acceso para datasets de PowerBI',
      en: 'Access requests for PowerBI Datasets'
    },
    subtitle_reports: {
      es: 'Solicitudes de acceso para reportes de PowerBI',
      en: 'Access requests for PowerBI Reports'
    },
    subtitle_reports_lds: {
      es: 'Solicitudes de acceso para reportes de Looker Data Studio',
      en: 'Access requests for Looker Data Studio Reports'
    },
    subtitle_datasources_gds: {
      es: 'Solicitudes de acceso para datasources de Looker Data Studio',
      en: 'Access requests for Looker Data Studio Datasources'
    }
  },
  metadata_: {
    nivel: 2,
    subtitle_tables: {
      es: 'Solicitudes de cambio de metadata para tablas de BigQuery',
      en: 'Change metadata requests for BigQuery tables'
    },
    subtitle_datasources: {
      es: 'Solicitudes de cambio de metadata para datasources de Tableau',
      en: 'Change metadata requests for Tableau Datasources'
    },
    subtitle_dashboards: {
      es: 'Solicitudes de cambio de metadata para dashboards de Tableau',
      en: 'Change metadata requests for Tableau Dashboards'
    },
    subtitle_datasets: {
      es: 'Solicitudes de cambio de metadata para datasets de PowerBI',
      en: 'Change metadata requests for PowerBI Datasets'
    },
    subtitle_reports: {
      es: 'Solicitudes de cambio de metadata para reportes de PowerBI',
      en: 'Change metadata requests for PowerBI Reports'
    },
    subtitle_reports_lds: {
      es: 'Solicitudes de cambio de metadata para reportes de Looker Data Studio',
      en: 'Change metadata for Looker Data Studio Reports'
    },
    subtitle_datasources_gds: {
      es: 'Solicitudes de cambio de metadata para datasources de Looker Data Studio',
      en: 'Change metadata for Looker Data Studio Datasources'
    }
  },
  tablas: {
    nivel: 2,
    table: {
      es: 'Tabla',
      en: 'Table'
    },
    user: {
      es: 'Usuario',
      en: 'User'
    },
    request: {
      es: 'Solicitud',
      en: 'Request'
    },
    datasource: {
      es: 'Datasource',
      en: 'Datasource'
    },
    dashboard: {
      es: 'Dashboard',
      en: 'Dashboard'
    },
    dataset: {
      es: 'Dataset',
      en: 'Dataset'
    },
    report: {
      es: 'Reporte',
      en: 'Report'
    },
    request_date: {
      es: 'Fecha de solicitud',
      en: 'Request date'
    },
    actions: {
      es: 'Acciones',
      en: 'Actions'
    },
    applicant: {
      es: 'Solicitante',
      en: 'Applicant'
    },
    area: {
      es: 'Área',
      en: 'Area'
    },
    profile: {
      es: 'Perfil',
      en: 'Profile'
    },
    status: {
      es: 'Estado',
      en: 'Status'
    },
    project: {
      es: 'Proyecto',
      en: 'Project'
    },
    end_date: {
      es: 'Fecha fin',
      en: 'End date'
    },
    details: {
      es: 'Detalles',
      en: 'Details'
    },
    source: {
      es: 'Fuente',
      en: 'Source'
    },
    benefited: {
      es: 'Beneficiado',
      en: 'Benefited'
    }
  },
  no_ownership: {
    es: 'No tienes objetos para aprobar',
    en: "You don't have objects to approve"
  },
  no_ownership_subtitle: {
    es: 'Una vez que te asignen un objeto podrás aceptarlo aquí',
    en: 'Once an object is assigned to you, you can accept it here'
  },
  no_requests: {
    es: 'Aún no tienes solicitudes',
    en: "You don't have requests yet"
  },
  no_requests_subtitle: {
    es: 'Una vez que te soliciten un objeto podrás aceptarlo aquí',
    en: 'Once an object is requested you can accept it here'
  },
  tables: {
    es: 'Tablas',
    en: 'Tables'
  },
  datasources: {
    es: 'Datasources de Tableau',
    en: 'Tableau Datasources'
  },
  dashboards: {
    es: 'Dashboards de Tableau',
    en: 'Tableau Dashboards'
  },
  datasets: {
    es: 'Datasets de PowerBI',
    en: 'PowerBI Datasets'
  },
  reports: {
    es: 'Reportes de PowerBI',
    en: 'PowerBI Reports'
  },
  reports_lds: {
    es: 'Reportes de LS',
    en: 'LS Reports'
  },
  datasources_lds: {
    es: 'Datasources de LS',
    en: 'LS Datasources'
  },
  object_type: {
    es: 'Tipo de objeto',
    en: 'Object Type'
  },
  search_filters: {
    es: 'Filtros de Búsqueda',
    en: 'Search Filters'
  },
  text_filter: {
    es: 'Filtro de texto',
    en: 'Text filter'
  },
  ownership_modal: {
    es: 'Propiedad',
    en: 'Ownership'
  },
  view_request: {
    es: 'Ver solicitud',
    en: 'View request'
  },
  view_change_metadata: {
    es: 'Ver cambio de metadata',
    en: 'View change_metadata'
  },
  metadata: {
    es: 'Detalles de la metadata',
    en: 'Table metadata details'
  },
  view_details: {
    es: 'Ver detalles',
    en: 'View details'
  },
  only_prod: {
    es: 'Solo se asignarán tablas en entorno "prod" y su dominio actual',
    en: 'Only tables in "prod" environment and your current domain will be assigned'
  },
  revision: {
    es: 'En revisión',
    en: 'Revision'
  },
  approved: {
    es: 'Aprobados',
    en: 'Approved'
  },
  rejected: {
    es: 'Rechazados',
    en: 'Rejected'
  },
  processing: {
    es: 'Masivo',
    en: 'Massive'
  },
  partially_processed: {
    es: 'Masivo - Errores',
    en: 'Massive - Errors'
  }
};
export default labels;